var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M9.41042 3.57733C9.73586 3.25189 10.2635 3.25189 10.5889 3.57733L16.4223 9.41066C16.7477 9.7361 16.7477 10.2637 16.4223 10.5892L10.5889 16.4225C10.2635 16.7479 9.73586 16.7479 9.41042 16.4225C9.08498 16.0971 9.08498 15.5694 9.41042 15.244L13.8212 10.8333H4.16634C3.7061 10.8333 3.33301 10.4602 3.33301 9.99992C3.33301 9.53968 3.7061 9.16658 4.16634 9.16658H13.8212L9.41042 4.75584C9.08498 4.4304 9.08498 3.90277 9.41042 3.57733Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.3ac973f2f4b4787549a3777698524b22.svg";
export { ForwardRef as ReactComponent };